import {Component, OnInit, ViewChild} from '@angular/core';
import { PropertiesService }



  from '../../admin-services/properties.service';
import { FormControl, FormGroup, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {first} from "rxjs/operators";
import {AlertService} from "../../../services/alert.service";
import {CareService} from "../../admin-services/care.service";
import {UserService} from "../../../services/user-services/user.service";
import { MatSelect, MatSelectModule } from "@angular/material/select";
import {document} from "ngx-bootstrap/utils";
import {fromEvent} from "rxjs";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatOptionModule } from '@angular/material/core';
import { NgxIntlTelInputModule } from '@justin-s/ngx-intl-tel-input';
import { NgClass, NgFor, NgIf, DatePipe } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-leads',
    templateUrl: './leads.component.html',
    styleUrls: ['./leads.component.scss'],
    standalone: true,
    imports: [MatFormFieldModule, NgClass, MatSelectModule, FormsModule, ReactiveFormsModule, NgxIntlTelInputModule, MatOptionModule, NgFor, NgIf, MatDatepickerModule, DatePipe]
})
export class LeadsComponent implements OnInit {

  leadArray: any[] = [];
  lead: any;
  isSending: boolean;
  partners;
  agents: any;
  formNote: UntypedFormGroup;
  activeLead: null;
  public listControl = [];
  public hasSearched:boolean=false;
  public hasChangedFilter:boolean=false;
  public statusFC: FormControl = new FormControl<string|null>(null);
  public metropoleFC: FormControl = new FormControl<string|null>(null);
  public contactFC: FormControl = new FormControl<string|null>(null);
  public partnerFC: FormControl = new FormControl<string|null>(null);
  public pageViewFC: FormControl = new FormControl<string|null>(null);
  public dateFC: FormControl = new FormControl<string|null>(null);

  public statusList : string[] = ['contacted' ,'pending', 'responding', 'dead', 'incommunicated'];
  public agentList:any[]= [];
  public partnerList:any[]= [];
  public metropoleList:any[]= [];
  public pageViewList:any[]= ['pay-overview', 'information', 'calendar', 'property'];
  dispDateFilter = false;
  dispoFilter = null;
  selectedValue: string;


  dateRange = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });

  public isLoading:boolean=false;
  private page:number=1;
  private perpage:number=10;
  public hasMoreToLoad:boolean=true;
  public totalLeads: number;
  public isLoadingMore:boolean=false;
  total;

  constructor(
    private carePropertiesService: PropertiesService,
    private careService: CareService,
    private userService: UserService,
    private fb: UntypedFormBuilder,
    private modalService: NgbModal,
    private alertService: AlertService,

  ) { }

  ngOnInit(): void {
    this.getLeadsEs();
    this.getFilterContents();
  }

  getLeadsEs(){
    this.leadArray = [];
    this.carePropertiesService.getLeadsEs().subscribe(async data => {
      this.partners  = data.partners;
      this.agents  = data.agents;
      this.leadArray = data.leads;
      this.leadArray.forEach((lead) => {
        if (lead.user.careDatas) {
          this.listControl[lead.user.id] = lead.user.careDatas.status;
          lead.user.careDatas = JSON.parse(lead.user.careDatas);
        }
      });
    });
  }

  getLeads() {
    this.leadArray = [];
    this.carePropertiesService.getLeadsEs().subscribe(async data => {
      this.partners  = data.partners;
      this.agents  = data.agents;
      this.leadArray = data.leads;

      this.leadArray.forEach((lead) => {
        if (lead.user.careDatas) {
          this.listControl[lead.user.id] = lead.user.careDatas.status;
          lead.user.careDatas = JSON.parse(lead.user.careDatas);
        }
      });
    });
  }

  private getFilterContents(): void {
    this.careService.getLeadFilters().pipe(first()).subscribe(data => {
      this.metropoleList = data.metropoles;
      this.partnerList = data.partners;
      this.agentList = data.agents;
    })

  }


  getAvatar(user){
    let name = 'NA';
    if(user.firstname && user.lastname){
      name = user.firstname[0] + user.lastname[0];
    }
    return '<h1>'+ name +'</h1>';
    /*if(!user || !user.avatar || user.avatar === 'default-avatar.png'){
      let name = 'NA';
      if(user.firstname && user.lastname){
        name = user.firstname[0] + user.lastname[0];
      }
      return '<h1>'+ name +'</h1>';
    }
    return ('<img checkurl src="'+ user.avatar +'" alt="" class="br-24 profile-image me-3" />');*/
  }

  getPartnerLogo(partner_id){
    let t;
    this.partners.forEach(element => {
      if(element.id == partner_id){
         t = element.logo;
      }
    });
    return t;
  }

  getPageReached(leads){
    let highestPage = null;
    leads.forEach(element => {
      if(!highestPage){
        highestPage = element.page_reached;
      }
      else{
        if(element.page_reached == "property" && highestPage != 'calendar' && highestPage != 'payment' ){
          highestPage = 'property';
        }
        if(element.page_reached == "calendar" && highestPage != 'payment' ){
          highestPage = 'calendar';
        }
        if(element.page_reached == "payment"){
          highestPage = 'payment';
        }
      }
    });
    return highestPage;
  }

  public getAgentAvatar(agentId,mode){
    let agent = {firstname: 'Alban'};
    this.agents.forEach(element => {
      if(element.id == agentId){
        agent = element;
      }
    });
    if(mode == 'img'){
      if(agent){
        const n = agent.firstname.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        return '/assets/img/admin/agents/'+ n.toLowerCase()  + '.webp';
      }
    }
    if(mode == 'name'){
      if(agent){
        return agent.firstname;
      }
    }
   }

  public leaveNote(modale, lead):void {
    this.activeLead = lead ? lead: null;
    const d = lead.user.careDatas? lead.user.careDatas.note : null;
      this.formNote = this.fb.group({
      content:[d] ,
    })
    this.modalService.open(modale, {size:'sm', centered:true});
  }


  public sendNote(): boolean {
    if (!this.activeLead){return false}
    this.isSending = true;
    this.careService.addNoteToLead({
      // @ts-ignore
      id: this.activeLead.user.id,
      note:this.formNote.value.content}).pipe(first()).subscribe((data: any) => {
      this.isSending = false;
      if (data.status == 'success') {
        // @ts-ignore
        this.activeLead.user.careDatas = data.careDatas;
        // @ts-ignore
        this.activeLead.user.careDatas.note = this.formNote.value.content;
        this.modalService.dismissAll();
        this.alertService.openSnackBar('Note mise à jour correctement', 'snack-success');
      } else {
        this.alertService.openSnackBar('Un problème est suvenu, la note n\'a pas pu être laissée', 'snack-error');
      }
    });
  }

  printStatus(status){
    if (status == 'contacted') return ('En échange');
    if (status == 'pending') return ('En attente');
    if (status == 'responding') return('Pas de réponse');
    if (status == 'dead') return('Mort');
    if (status == 'incommunicated') return('Pas contacté');
    return 'N/A';
  }

  printPageView(pageView){
    if (pageView == 'pay-overview') return ('Payment');
    if (pageView == 'calendar') return ('Calendar');
    if (pageView == 'information') return ('Information');
    if (pageView == 'property') return ('Property');
    return 'N/A';
  }

  public leaveStatus(modale, lead):void {
    this.activeLead = lead ? lead: null;
    const d = lead.user.careDatas? lead.user.careDatas.status : null;
    this.formNote = this.fb.group({
      content:[d] ,
    })
    this.modalService.open(modale, {size:'sm', centered:true});
  }

  public getTranslate(status){
    if (status == 'En échange') return ('contacted');
    if (status == 'En attente') return ('pending');
    if (status == 'Pas de réponse') return('responding');
    if (status == 'Mort') return('dead');
    if (status == 'Pas contacté') return('incommunicated');
  }

  public sendStatus(value, lead) {

    this.isSending = true;
    this.careService.addStatusToLead({
      // @ts-ignore
      id: lead.user.id,
      status:value
    }).pipe(first()).subscribe((data: any) => {
      this.isSending = false;
      if (data.status == 'success') {
        lead.user.careDatas = data.careDatas;
        lead.user.careDatas.status = value;
        this.alertService.openSnackBar('Statut mise à jour correctement', 'snack-success');
      } else {
        this.alertService.openSnackBar('Un problème est suvenu, le statut n\'a pas pu être modifié', 'snack-error');
      }
    });
  }

  private setLeadAndVars(data) {
    if (this.page == 1) {
      this.leadArray = data.data;
    } else {
      this.leadArray = [ ...this.leadArray, ...data.data];
    }

    if (data.current_page >= data.last_page) {
      this.hasMoreToLoad = false;
    }

    this.isLoading = false;
    this.isLoadingMore = false;
    this.hasChangedFilter = false;
  }

  clearAll(){
    this.statusFC.setValue(null);
    this.partnerFC.setValue(null);
    this.contactFC.setValue(null);
    this.metropoleFC.setValue(null);
    this.pageViewFC.setValue(null);
    this.dateRange.value.start = null;
    this.dateRange.value.end = null;
    this.doFilter();
  }


  public doFilter(isInit?):void {
    if (isInit) {
      const r = this.userService.getFromLocal('adminLeadFilter')
      if (r) {
        const rSplit = r.split('&');
        rSplit.forEach(param => {
          const paramSplit = param.split('=')[param.split('=').length - 1];
          if (param.includes('status')) {
            this.statusFC.setValue(paramSplit);
          }
          if (param.includes('partner')) {
            this.partnerFC.setValue(paramSplit);
          }
          if (param.includes('owner')) {
            this.contactFC.setValue(paramSplit);
          }
          if (param.includes('city')) {
            this.metropoleFC.setValue(paramSplit);
          }
          if (param.includes('pageView')) {
            this.pageViewFC.setValue(paramSplit);
          }
        })
      }
    }
    let request = '';
    if (this.partnerFC.value) {
      request += '&partner='+this.partnerFC.value;
    }
    if (this.contactFC.value) {
      request += '&owner='+this.contactFC.value;
    }
    if (this.metropoleFC.value) {
      request += '&city='+this.metropoleFC.value;
    }
    if (this.statusFC.value) {
      request += '&status='+this.statusFC.value;
    }
    if (this.pageViewFC.value) {
      request += '&pageView='+this.pageViewFC.value;
    }

    if (this.dateRange.value.start && this.dateRange.value.start) {
      const start = new Date(this.dateRange.value.start).toISOString()
      const end = new Date(this.dateRange.value.end).toISOString();
      const requestDate = `${start}|${end}`;
      request += '&date='+requestDate;
    }

    if (this.hasChangedFilter) {
      this.page =1;
      this.hasMoreToLoad = true;
    }

    this.userService.storeInLocal('adminLeadFilter', request)

    this.careService.getAllLeads(this.page, request).pipe(first()).subscribe(data => {
      this.totalLeads = data.total;
      this.leadArray = data.leads;
      this.leadArray.forEach((lead) => {
        if (lead.user.careDatas) {
          this.listControl[lead.user.id] = lead.user.careDatas.status;
          lead.user.careDatas = JSON.parse(lead.user.careDatas);
        }
      });
    })
  }

  getOptionClass(value: string): string {
    if(value){
      return `btn-status-${value}`;

    }
    else {
      return `btn-status-incommunicated`;
    }
  }


}
